import { SelfCheckIn } from '~/app/components'
import { useEffect, useMemo } from 'react'
import { isoToFormat } from '~/app/utils/useIsoToFormat'
import { useQrCodeQuery } from '~/__generated__/app/query/order-details/qrcode.graphql'
import useQrCode from '~/app/components/order-list/hooks/useQrCode'
import { SelfCheckInDomesticProps } from '~/app/components/order-list/details/SelfCheckIn/SelfCheckInModal'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'
import { getDomesticOptions } from '~/app/components/order-converter/converter/DomesticOrderConverter'

type SelfCheckInContainerProps = Omit<SelfCheckInDomesticProps, 'isOpened'> & {
  reservationId: string
  onClickBack: () => void
}
const SelfCheckInContainer = ({
  propertyName,
  roomTypeName,
  checkInAt,
  checkOutAt,
  name,
  virtualPhoneNum,
  phone,
  reservationId,
  ratePlanTitle,
  benefits,
  pickupType,
  visitType,
  roomType,
  onClickBack,
}: SelfCheckInContainerProps) => {
  const duration = useMemo<[string, string][]>(
    () =>
      [checkInAt, checkOutAt].map(date => [
        isoToFormat(date, 'yyyy.MM.dd (ccc)'),
        isoToFormat(date, 'HH:mm'),
      ]),
    [checkInAt, checkOutAt]
  )

  const { loading, data } = useQrCodeQuery({
    variables: {
      reservationNo: reservationId,
      phoneNo: phone,
    },
    skip: !reservationId || !phone,
  })

  const [qrCode] = useQrCode(data?.qrCode?.qrInfo)

  // 기기 밝기 최대화
  useEffect(() => {
    const yaNative = getYaNative()
    if (qrCode && isNative(yaNative)) {
      yaNative.brightnessMax({ on: true })
    }
    return () => {
      if (isNative(yaNative)) {
        yaNative.brightnessMax({ on: false })
      }
    }
  }, [qrCode])

  const options = getDomesticOptions({ benefits, pickupType, visitType })
  const capacityText = useMemo(() => {
    const { capacity, maxCapacity } = roomType?.data || {}

    return capacity && maxCapacity ? `기준 ${capacity}명 / 최대 ${maxCapacity}명` : ''
  }, [roomType])

  return (
    <SelfCheckIn
      title={propertyName}
      subTitle={roomTypeName}
      ratePlanTitle={ratePlanTitle}
      options={options}
      capacity={capacityText}
      startAt={duration[0]}
      endAt={duration[1]}
      userName={name}
      phone={virtualPhoneNum}
      selfCheckInNumber={reservationId}
      loading={loading}
      qrCode={qrCode}
      onClickBack={onClickBack}
    />
  )
}

export default SelfCheckInContainer
